import { render, staticRenderFns } from "./ListGroupIcon.vue?vue&type=template&id=2405f978&"
import script from "./ListGroupIcon.vue?vue&type=script&lang=js&"
export * from "./ListGroupIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports